import React, { useState } from 'react';
import { Button } from '@chakra-ui/react';
import { QrCode } from '@phosphor-icons/react';
import QRCode from 'qrcode';

import { useCustomToast } from '../../../hooks/useCustomToast';

export const getDirectoryUrl = (dropPointId: string) => `https://www.dropfriends.com/dp/directory/${dropPointId}`;

interface DownloadDirectoryQrCodeProps {
  dropPointId: string;
}

export const DownloadDirectoryQrCode = ({ dropPointId }: DownloadDirectoryQrCodeProps) => {
  const toast = useCustomToast();
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    try {
      setLoading(true);
      const dataUrl = await QRCode.toDataURL(getDirectoryUrl(dropPointId), {
        width: 1024,
        margin: 2,
        errorCorrectionLevel: 'H',
      });
      const link = document.createElement('a');
      link.href = dataUrl;
      link.download = `dropfriends-verzeichnis-qr-${dropPointId}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.log(error);
      toast({ description: 'QR-Code konnte nicht erstellt werden.', status: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button variant="outline" colorScheme="brand" size="xs" rightIcon={<QrCode />} onClick={handleDownload} isLoading={loading}>
      Verzeichnis QR-Code
    </Button>
  );
};
